/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CriteriaContentObject } from '../../models/criteria-content-object';
import { TimelineContent } from '../../models/timeline-content';

export interface ApiMasterTimelineContentGetByCriteriaPost$Params {
      body?: CriteriaContentObject
}

export function apiMasterTimelineContentGetByCriteriaPost(http: HttpClient, rootUrl: string, params?: ApiMasterTimelineContentGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TimelineContent>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterTimelineContentGetByCriteriaPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TimelineContent>>;
    })
  );
}

apiMasterTimelineContentGetByCriteriaPost.PATH = '/api/Master/TimelineContent/GetByCriteria';
